export enum BusinessTypeEnum {
  CORPORATION = 'corporate',
  INDIVIDUAL = 'individual',
  INDIVIDUAL_VAT = 'individual_registered_vat',
}
